module.exports = __webpack_public_path__ + "static/media/accounts.6d8a0533.svg";